import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Privacy from "@/pages/Privacy";
import Signup from "@/pages/Signup";
import Onboarding from "@/pages/Onboarding";
import AuthCallback from "@/pages/AuthCallback";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Simulator from "@/pages/Simulator";
import AdminAnalytics from "@/pages/AdminAnalytics";
import { AuthProvider, useAuth } from "@/context/AuthContext";

// Send cookies with every API call so the session_token cookie flows.
axios.defaults.withCredentials = true;

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen bg-[#060B19] text-white flex items-center justify-center text-sm text-slate-400">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/signup" replace />;
  return children;
};

const AppRoutes = () => {
  const location = useLocation();
  // Detect OAuth callback synchronously during render (race-condition safe)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/demo" element={<Dashboard demoMode />} />
      <Route
        path="/onboarding"
        element={
          <ProtectedRoute>
            <Onboarding />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/simulator"
        element={
          <ProtectedRoute>
            <Simulator />
          </ProtectedRoute>
        }
      />
      <Route path="/admin/analytics" element={<AdminAnalytics />} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster theme="dark" richColors position="top-right" />
          <AppRoutes />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
